import { put, all } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { keysToCamelCase } from "lib/helpers";
import messages from "../messages";

function* createLicense(action) {
  const { id, identifier, expires } = action.payload;
  const { success, data, error } = yield* makeRequest.post("/profile/licenses", {
    license: { id, identifier, expires },
  });
  if (success && data) {
    yield all([
      put(actions.setProfile(keysToCamelCase(data.body))),
      put(actions.newSuccessEvent({ message: messages.CREATE_LICENSE_SUCCESS })),
    ]);
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_CREATING_LICENSE,
    });
  }
  return null;
}

export default createLicense;
